export default __webpack_public_path__ + "static/media/allmenu.c45f31bb.svg";